const _ = require("lodash");

// Takes in a string that is assumed to be a boolean and returns "true" if
// the trimmed, case-insensitive value is "true". Otherwise returns "".
// Used because we generally use string inputs in BAEditor for booleans
// because they can be left empty and can be added after an engine already exists.
const ensureBoolStringConvention = function(potentialBool) {
	if (potentialBool) {
		const tmpVar = _.clone(potentialBool)
			.toString()
			.trim();
		if (/^t(rue)?$/i.test(tmpVar)) {
			return "true";
		}
	}
	return "";
};

module.exports = {
	ensureBoolStringConvention,
};
